// ============================================
// ALMACEN/MODALARTICULOINTERNO.JS — alta propia de articulos internos (SUB-ALMACENES C, 2026-10-19)
// ============================================
// Consumibles de oficina (papel, cafe, toner) y herramientas (taladro, escalera, multimetro): nombre, unidad, tipo, foto
// opcional (SubirImagen -> Cloudinary) y, si existe en el catalogo Syscom, se liga. NUNCA aparecen en La Tienda ni en
// cotizaciones (viven en su propia tabla).
import React, { useEffect, useState } from 'react';
import { fetchAuth } from '../../utils/sesion';
import { API_BASE } from '../../config/api';
import SubirImagen from '../SubirImagen';
import { Modal, C, inputBase, labelStyle, btnCancelar, btnOk, Foto } from './ui';

const UNIDADES = [['pieza', 'Pieza'], ['caja', 'Caja'], ['paquete', 'Paquete'], ['rollo', 'Rollo'], ['metro', 'Metro'], ['litro', 'Litro'], ['kilo', 'Kilo']];

export default function ModalArticuloInterno({ tipo, articulo, onCerrar, onHecho }) {
  const editando = !!(articulo && articulo.id);
  const [nombre, setNombre] = useState(articulo ? articulo.nombre : '');
  const [unidad, setUnidad] = useState(articulo ? articulo.unidad : 'pieza');
  const [marca, setMarca] = useState((articulo && articulo.marca) || '');
  const [modelo, setModelo] = useState((articulo && articulo.modelo) || '');
  const [nota, setNota] = useState((articulo && articulo.nota) || '');
  const [imagen, setImagen] = useState((articulo && articulo.imagen_propia) || null);
  const [syscomId, setSyscomId] = useState((articulo && articulo.syscom_producto_id) || '');
  const [syscomQ, setSyscomQ] = useState('');
  const [syscomRes, setSyscomRes] = useState([]);
  const [syscomElegido, setSyscomElegido] = useState(articulo && articulo.syscom_producto_id ? { referencia_id: articulo.syscom_producto_id, modelo: articulo.syscom_modelo, nombre: articulo.syscom_titulo } : null);
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  // Ligar al catalogo Syscom (opcional): busca en La Tienda y toma solo productos Syscom.
  useEffect(() => {
    const t = syscomQ.trim();
    if (t.length < 2) { setSyscomRes([]); return undefined; }
    let vivo = true;
    const h = setTimeout(async () => {
      try {
        const r = await fetchAuth(`${API_BASE}/api/tienda/buscar?limit=8&q=${encodeURIComponent(t)}`);
        const d = await r.json().catch(() => ({}));
        if (vivo) setSyscomRes(r.ok && d.ok ? (d.productos || []).filter(p => p.tipo === 'syscom_producto').map(p => ({ referencia_id: String(p.referencia_id), modelo: p.modelo, nombre: p.nombre, imagen_url: p.imagen_url })) : []);
      } catch (e) { if (vivo && e.code !== 'SESION_EXPIRADA') setSyscomRes([]); }
    }, 300);
    return () => { vivo = false; clearTimeout(h); };
  }, [syscomQ]);

  const listo = nombre.trim().length > 0 && !enviando;
  const guardar = async () => {
    if (!listo) return;
    setEnviando(true); setError('');
    try {
      const body = { nombre: nombre.trim(), tipo, unidad, marca: marca.trim() || null, modelo: modelo.trim() || null, nota: nota.trim() || null, imagen_url: imagen || null, syscom_producto_id: syscomId || null };
      const r = await fetchAuth(`${API_BASE}/api/inventario/articulos-internos${editando ? `/${articulo.id}` : ''}`, { method: editando ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || 'No se pudo guardar');
      onHecho(d.articulo);
    } catch (e) { if (e.code !== 'SESION_EXPIRADA') setError(e.message); setEnviando(false); }
  };

  return (
    <Modal titulo={`${editando ? '✏️ Editar' : '➕ Nuevo'} ${tipo === 'herramienta' ? 'tipo de herramienta' : 'consumible'}`} onCerrar={onCerrar} pie={<>
      <button onClick={onCerrar} style={btnCancelar}>Cancelar</button>
      <button onClick={guardar} disabled={!listo} style={btnOk(listo)}>{enviando ? 'Guardando…' : 'Guardar'}</button>
    </>}>
      <div style={{ fontSize: 11, color: C.grisClaro, marginTop: 4, lineHeight: 1.5 }}>
        {tipo === 'herramienta' ? 'Un tipo de herramienta (p. ej. "Taladro Bosch GSB 13"). Cada taladro físico se da de alta después como activo con su número.' : 'Lo que usa la oficina y no se vende: papel, café, tóner…'} <strong>Nunca aparece en La Tienda ni en cotizaciones.</strong>
      </div>
      <label style={labelStyle}>Nombre</label>
      <input autoFocus value={nombre} onChange={(e) => setNombre(e.target.value)} style={inputBase} placeholder={tipo === 'herramienta' ? 'Taladro, escalera, multímetro…' : 'Papel carta, café, tóner…'} maxLength={200} />
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Unidad</label>
          <select value={unidad} onChange={(e) => setUnidad(e.target.value)} style={inputBase}>{UNIDADES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        </div>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Marca</label>
          <input value={marca} onChange={(e) => setMarca(e.target.value)} style={inputBase} maxLength={100} />
        </div>
      </div>
      <label style={labelStyle}>Modelo (opcional)</label>
      <input value={modelo} onChange={(e) => setModelo(e.target.value)} style={inputBase} maxLength={150} />
      <label style={labelStyle}>Foto (opcional)</label>
      <SubirImagen value={imagen} onChange={(url) => setImagen(url)} onDelete={() => setImagen(null)} folder="beep-os/almacen-internos" label="" aspectRatio="square" />
      <label style={labelStyle}>¿Existe en el catálogo Syscom? (opcional)</label>
      {syscomElegido ? (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12.5, color: C.gris }}>
          <Foto src={syscomElegido.imagen_url} tam={32} /><span style={{ flex: 1 }}>{syscomElegido.modelo || syscomElegido.referencia_id} · {syscomElegido.nombre}</span>
          <button onClick={() => { setSyscomElegido(null); setSyscomId(''); }} style={{ border: 'none', background: 'transparent', color: C.rojo, cursor: 'pointer', fontWeight: 700 }}>quitar</button>
        </div>
      ) : (
        <>
          <input value={syscomQ} onChange={(e) => setSyscomQ(e.target.value)} style={inputBase} placeholder="Buscar modelo en Syscom…" />
          {syscomRes.length > 0 && <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6 }}>
            {syscomRes.map(p => <button key={p.referencia_id} type="button" onClick={() => { setSyscomElegido(p); setSyscomId(p.referencia_id); setSyscomRes([]); setSyscomQ(''); }} style={{ display: 'flex', gap: 8, alignItems: 'center', textAlign: 'left', padding: '6px 8px', minHeight: 40, border: `1px solid ${C.borde}`, borderRadius: 8, background: '#fff', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12 }}><Foto src={p.imagen_url} tam={28} /><span>{p.modelo} · {p.nombre}</span></button>)}
          </div>}
        </>
      )}
      <label style={labelStyle}>Nota (opcional)</label>
      <input value={nota} onChange={(e) => setNota(e.target.value)} style={inputBase} maxLength={500} />
      {error && <div style={{ marginTop: 10, background: '#fde8e8', color: '#b02020', borderRadius: 10, padding: '8px 10px', fontSize: 12 }}>{error}</div>}
    </Modal>
  );
}
